<div fxLayout="row" fxLayoutAlign="center" class="m-1">
  <div fxFlex="100" fxFlex.gt-sm="1 1 460px" fxFlex.sm="1 1 460px">
    <div>
      <div fxLayout="row" fxLayoutAlign="space-between center" class="pt-3 pl-3 pr-3 mb-0">
        <h3 class="primary-color m-1">{{ 'TREATMENT.SELECT-TREATMENT-FROM-TTREATMENT-CARD' | translate }}</h3>

        <button mat-stroked-button (click)="back()">
          <mat-icon matSuffix class="mat-icon-rtl-mirror">navigate_before</mat-icon>
          {{ 'FUTURE-VISITS.BACK' | translate}}
        </button>
      </div>


      <div [formGroup]="form" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutAlign.gt-xs="start center">
        <div class="p-3 w-100" fxLayout="column" fxLayoutAlign="start stretch">

          <mat-radio-group formControlName="options">
            <mat-radio-button value="1" color="primary" class="m-1" [disabled]="hasTreatmentsFromSeries">{{ 'TREATMENT.TREATMENTS' | translate }}
            </mat-radio-button>
            <mat-radio-button value="3" color="primary" class="m-1" [disabled]="hasSelectedItemsFromPriceList()">{{ 'TREATMENT.SERIES' | translate }}
            </mat-radio-button>
            <mat-radio-button value="4" color="primary" class="m-1" [disabled]="hasTreatmentsFromSeries || hasSelectedItemsFromPriceList()">{{ 'TREATMENT.PROGRAM' | translate }}
            </mat-radio-button>
          </mat-radio-group>


          <div class="mt-2 p-3 mat-elevation-z6">

            <mat-form-field class="w-100" *ngIf="form.get('options').value > 1">
              <mat-label *ngIf="form.get('options').value === '3'">{{ 'TREATMENT.SELECT-SERIES' | translate }}
              </mat-label>
              <mat-label *ngIf="form.get('options').value === '4'">{{ 'TREATMENT.SELECT-PLAN' | translate }}</mat-label>
              <mat-select formControlName="group">
                <mat-option *ngFor="let group of treatmentGroup" [value]="group.ID">
                  {{group.Name}} {{ group.CreatedOn | amDateFormat: 'L'}}</mat-option>
              </mat-select>
              <button mat-button *ngIf="form.controls.group.value" matSuffix mat-icon-button aria-label="Clear"
                (click)="form.controls.group.setValue(undefined); $event.preventDefault();">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>

            <span *ngIf="selectedGroup"
              class="series-label">{{ selectedGroup.SubTreatmentsDoneCount}}/{{ selectedGroup.ActiveSubTreatmentCount}}</span>


            <div class="mt-3 container" 
            [ngClass]="{ 'treatments': form.value.options === '1', 'plan': form.value.options === '4', 'series':form.value.options === '3'  }">
              <div *ngFor="let currentTreatment of treatments; let index=index; let odd=odd; let even=even;">
                <app-treatment-row [treatment]="currentTreatment" [treatmentType]="form.get('options').value"
                  [odd]="odd" [even]="even"></app-treatment-row>
              </div>
            </div>

            <div class="mt-2">
              <button mat-raised-button color="primary" class="w-100 ok-button" [disabled]="!hasSelectedItems()"
                (click)="onOK()">
                <div fxLayout="row" fxLayoutAlign="space-around center">
                  <span style="font-size: 1.5em;">{{ 'COMMON.OK' | translate }}</span>
                  <span>{{ 'FIND-TIME.X-TREATMENT-SELECTED' | translate: { total: totalSelected() } }}</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>